import React from "react";
import { Card, CardBody, Label, Row } from 'reactstrap';
import Form from './Form'
// import { ModelContainerDetail } from '../Components/Model';
import FormBuilder from '../Components/FormBuilder';

function ContainerInfo(props) {
	// console.log('props container information', props);
	// const [Model, setModel] = React.useState({ ...ModelContainerDetail() });
	// console.log('Model', Model);
	return (
		<Card className="myCard">
			<CardBody>
				<Label style={{ color: 'black' }}><b>Container Information</b></Label>
				<br />
				<Row>
					<FormBuilder dataForm={Form.ContainerInfo} Model={props.Model} Catalog={props.Catalog} onChange={props.onChange} />
				</Row>
				<hr />
				<Label style={{ color: 'black' }}><b>General</b></Label>
				<br />
				<Row>
					<FormBuilder dataForm={Form.General} Model={props.Model} Catalog={props.Catalog} onChange={props.onChange} />
				</Row>
				<hr />
				<Label style={{ color: 'black' }}><b>Cargo</b></Label>
				<br />
				<Row>
					<FormBuilder dataForm={Form.Cargo} Model={props.Model} />
				</Row>
			</CardBody>
		</Card>
	);
}

export default ContainerInfo;